var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 6.94012 0 15.5C0 24.0599 7.164 31 16 31C24.836 31 32 24.0599 32 15.5C32 6.94012 24.836 0 16 0ZM16.3413 2.98762C19.6347 2.99408 23.1627 5.58129 24.2053 6.81354L24.5307 7.20104C26.7173 9.77662 29.2893 12.8069 29.2893 16.1988C29.2893 21.0025 25.316 23.7008 21.0787 25.8966C19.168 26.886 17.1053 27.8445 14.748 27.8445C8.69067 27.8445 3.59333 23.2345 3.59333 17.3665C3.59333 16.4545 3.82 15.5258 4.04933 14.5894C4.212 13.9242 4.37467 13.2551 4.45867 12.5886C5.18933 6.72571 8.41467 3.81171 15.688 3.01992C15.9049 2.99666 16.1231 2.98544 16.3413 2.98633V2.98762Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.7e8e159c221a7fe315587cbd8cbf4faa.svg";
export { ForwardRef as ReactComponent };